import { BigNumber } from '@ethersproject/bignumber'
import { formatCurrency } from '../../model'
import { BN_10_18 } from './constants'

const BN_10_16 = BigNumber.from(10).pow(16)

export function safeNumberToString(number: number): string {
  return number.toLocaleString('fullwide', { useGrouping: false })
}

export function bigNumber18DecimalsToPercent(bn: BigNumber): string {
  return `${bn.mod(100).gt(50) ? bn.mul(100).div(BN_10_18).add(1) : bn.mul(100).div(BN_10_18)}%`
}

export function bigNumber18DecimalsToPercentWithPrecision(bn: BigNumber, precision: number): string {
  return `${formatCurrency(precision, bn.mul(10 ** (precision + 2)).div(BN_10_18))}%`
}

export function bigNumber18DecimalsToDollars(bn: BigNumber): string {
  return `$${formatCurrency(2, bn.div(BN_10_16))}`
}
